import { BaseService } from './BaseService';

export interface ServiceCategory {
  id: string;
  name: string;
  slug: string;
  description: string;
  icon_url: string;
  is_active: boolean;
  service_count?: number;
  created_at?: string;
}

export interface ServiceCategoryListResponse {
  items: ServiceCategory[];
  total_count: number;
  page: number;
  limit: number;
  total_pages: number;
}

class ServiceCategoryService extends BaseService {
  private baseUrl = '/services/admin/categories';

  /**
   * List all service categories with pagination and search
   */
  async listCategories(
    page: number = 1,
    limit: number = 10,
    search: string = ''
  ): Promise<ServiceCategoryListResponse> {
    const params = new URLSearchParams();
    params.append('page', page.toString());
    params.append('limit', limit.toString());
    if (search) {
      params.append('search', search);
    }

    return this.get<ServiceCategoryListResponse>(
      `${this.baseUrl}?${params.toString()}`
    );
  }

  /**
   * Get a single service category
   */
  async getCategory(id: string): Promise<ServiceCategory> {
    return this.get<ServiceCategory>(`${this.baseUrl}/${id}/`);
  }

  /**
   * Create a new service category
   */
  async createCategory(data: Partial<ServiceCategory>): Promise<ServiceCategory> {
    return this.post<ServiceCategory>(`${this.baseUrl}/`, data);
  }

  /**
   * Update a service category
   */
  async updateCategory(id: string, data: Partial<ServiceCategory>): Promise<ServiceCategory> {
    return this.patch<ServiceCategory>(`${this.baseUrl}/${id}/`, data);
  }

  /**
   * Delete a service category
   */
  async deleteCategory(id: string): Promise<void> {
    await this.delete<void>(`${this.baseUrl}/${id}/`);
  }
}

export default new ServiceCategoryService();
